"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlFromProvider = void 0;
function getUrlFromProvider(provider) {
    var _a, _b, _c, _d, _e, _f;
    const rpcUrl = (_f = (_b = (_a = provider === null || provider === void 0 ? void 0 : provider.connection) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : (_e = (_d = (_c = provider.providers) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.connection) === null || _e === void 0 ? void 0 : _e.url) !== null && _f !== void 0 ? _f : '';
    return rpcUrl;
}
exports.getUrlFromProvider = getUrlFromProvider;
